module.exports = __webpack_public_path__ + "static/media/Settings.51bf3548.svg";